import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { SharedNavBar, NavData } from 'Guide/PageNavigation/SharedNavBar';

export function TeamNav(props: NavData) {
   const { breadCrumbs, navTabs } = props;

   return <SharedNavBar breadCrumbs={breadCrumbs} navTabs={navTabs} />;
}

initializeChakraComponent('TeamNavComponent', TeamNav);
